module.exports = __webpack_public_path__ + "img/frequency-icon.e615b8a8.svg";